import Cookies from 'js-cookie'

const consentEl = $('.dialog.consent')

function ConsentItem(id, options) {
    this.id = id
    this.cookieName = 'shoerts-' + this.id
    this.cookie = Cookies.get(this.cookieName) 
    this.consent = this.cookie ? this.cookie === 'confirm'  : false

    this.optInOut = $('.opt-in-out input#'+this.id)
    if (this.optInOut.length > 0) this.optInOut[0].checked = this.consent

    this.reject = function() {
        Cookies.set(this.cookieName,'reject')
        this.consent = false
        if (options && options.reject) options.reject()
    },
    this.confirm = function() {
        console.log(this.cookieName)
        Cookies.set(this.cookieName,'confirm')
        this.consent = true
        if (options && options.confirm) options.confirm()
    }
}

function rejectAll() {
    for (let item of Object.values(Consent)) {
        item.reject()
    }
}

function confirmAll() {
    for (let item of Object.values(Consent)) {
        item.confirm()
    }
}

window.Consent = {
    matomo: new ConsentItem('matomo', {
        confirm: function() {
            if ('_paq' in window) _paq.push(['rememberCookieConsentGiven']);
            // Cookies.remove('matomo_ignore')
            // if (window.initMatomo) window.initMatomo()
            // $('button.switch#kwb-matomo').attr("aria-checked", "true");
        },
        reject: function() {
            if ('_paq' in window) _paq.push(['forgetCookieConsentGiven']);
            // Cookies.set('matomo_ignore','ignore')
        }
    }),
    // shopify: new ConsentItem('shopify', {
    //     confirm: function() {
    //         if (initShopify !== undefined) initShopify()
    //     },
    //     reject: function(consent) {
    //         console.log("reject shopify")
    //         if (!shopifyInitialized) $('.product-placeholder').addClass('visible') // show when not consented already
    //     }
    // })
};

const noCookies = !Consent.matomo.cookie//Object.values(Consent).every(i => i.cookie === undefined)
if (noCookies) consentEl.addClass('visible')

consentEl.find('button#dialog-reject').on('click', function() {
    console.log("reject", Cookies)

    rejectAll()

    consentEl.removeClass('visible')
})

consentEl.find('button#dialog-confirm').on('click', function() {
    console.log("confirm", Cookies)

    confirmAll()
    
    consentEl.removeClass('visible')
})

$('.opt-in-out label input').on('click', function(e) {
    const checked = e.target.checked
    const id = e.target.id
    checked ? Consent[id].confirm() : Consent[id].reject()
})